<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      syncValueChange
                                      use-self-complete-feedback
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :config="config">
                    <template #customAction="{status,tags}">
                        <download-button v-if="differentHeads && tags['pass']"
                                         file-name="Bom Change Different Heads.zip"
                                         :url="downloadDifferentHeadsUrl()">
                            Download Bom Header
                        </download-button>
                    </template>
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Lin
// Date 2022-08-16 10:54:06

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";
import workflowTaskMixins, {WITHOUT_ATTACHMENT_TAG} from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import DownloadButton from "@/components/common/buttons/DownloadButton.vue";

export default {
    name: "sithMesPrdKamChangeWorkflowTaskView",
    components: {DownloadButton, WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins, emCommonUtilMixin],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        config() {
            return {
                'task_change_init': {
                    name: '变更申请',
                    variables: [
                        {
                            label: '变更原因',
                            name: 'changeReason',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                "Standard Reason for Change",
                                "Human Error",
                                "Misunderstanding/Ambiguity",
                                "Incorrect Data",
                                "Unavailable Data",
                                "No/Inadequate Validation",
                                "No/Inadequate Coordination/Communication",
                                "Equipment Error (eg. CAD, Computers)",
                                "Incorrect Specification",
                                "Poor Process",
                                "Unknown",
                                "Better Information Now Available",
                                "Available Information",
                                "Improved Materials",
                                "Better Equipment",
                                "Improved Analysis",
                                "Observation/Experience",
                                "Improved technology",
                                "Inspiration",
                                "Customer Request",
                                "Purchasing Request",
                                "Market Need",
                                "Sales Request",
                                "Manufacturing Request",
                                "Engineering Request",
                                "Packaging Request",
                                "ECC Request",
                                "CSC Request",
                                "Change of Strategy/Philosophy",
                                "Quality Request",
                                "Legal Requirement"
                            ],
                            require: true
                        },
                        {
                            needTag: 'fromKam',
                            label: '变更描述',
                            name: 'changeDescription',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            require: true
                        },
                        {
                            needTag: 'fromKam',
                            label: '变更详情',
                            // name: 'changeDetail',//fixme 应该包含name的配置，但增加后会导致之前的查询记录显示不出来，所以暂时这个还能用，相当于name为字符串undefined
                            type: this.VALUE_TYPE.TABLE,
                            rows: [
                                {
                                    changeItem: 'Material Quantity',
                                    oldValue: this.$_emWorkflowTaskMixin_businessData.materialQuantity
                                },
                                {
                                    changeItem: 'Material Direction',
                                    oldValue: this.$_emWorkflowTaskMixin_businessData.materialDescription
                                }
                            ],
                            fields: ['changeItem', 'oldValue', {
                                key: 'newValue',
                                isInput: true,
                                mutativeType: [{
                                    key: 'changeItem',
                                    value: 'Material Direction',
                                    activeType: 'select'
                                }],
                                options: [
                                    {value: 3, text: 'P'},
                                    {value: 1, text: 'R'},
                                    {value: 2, text: '3rd'},
                                ],
                                disableWhen: row => {
                                    return row.changeItem === 'Material Quantity' &&
                                        this.$_emWorkflowTaskMixin_businessData.createdBy === this.$_emWorkflowTaskMixin_businessData.projectOm
                                }
                            }],
                            disableAutoSave: true
                        },
                        {
                            needTag: 'fromBom',
                            label: '变更内容',
                            name: 'changedItems',
                            dataFieldName: 'changeDescription',
                            type: this.VALUE_TYPE.SELECT_MULTI,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: ['物料更新', 'Bom更新', '图纸更新'],
                            require: true,
                            changeTag: val => {
                                return this.buildTag('bom_change', val && val.indexOf('Bom更新') !== -1);
                            }
                        }
                    ],
                    changeTag: (businessData) => {
                        let tempList = [];
                        let name = 'fromBom';
                        if (businessData.changeType === 1) {
                            name = 'fromKam';
                            tempList.push(this.buildTag(WITHOUT_ATTACHMENT_TAG, true));
                        }
                        tempList.push(this.buildTag(name, true));
                        return tempList;
                    },
                    withAttachmentNotNull: true,
                    attachmentSaveTo: 'attachmentIds',
                    needCheck: {
                        api: process.env.VUE_APP_SITHMES_II_URL + "/bomChangeCompare/check?material=" + this.$_emWorkflowTaskMixin_businessData.materialNumber,
                        label: "BOM有效性检查",
                        activateByTag: 'bom_change',
                    },
                    approveToNextTask: 'task_do_change'
                },
                'task_do_change': {
                    name: 'DO执行变更',
                    variables: [
                        {
                            needTag: 'fromBom',
                            label: '是否通过',
                            name: 'passed',
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 11, text: '通过'},
                                {value: 12, text: '拒绝'},
                            ],
                            require: true,
                            changeTag: val => {
                                return this.buildTag('pass', val === 11);
                            }
                        }
                    ],
                    withComment: true,
                    forceApprove: true,
                    setApproveByBusinessData: (businessData) => {
                        if (businessData.makeOrBuy === 0) {//make
                            return 1;
                        } else {//buy
                            return 2;
                        }
                    },
                    setApproveByVariable: [
                        {
                            variableName: 'passed',
                            handler: (approve, val) => {
                                if (val === 12) {
                                    return val;
                                } else {
                                    return approve;
                                }
                            }
                        }
                    ],
                    changeTag: (businessData) => {
                        return this.buildTag('fromBom', businessData.changeType !== 1);
                    },
                    needCheck: {
                        api: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdKamChange/query/waiting?kamChangeId=" + this.$_emWorkflowTaskMixin_businessData.id,
                        label: "等待中物料检查",
                        activateByTag: 'pass',
                    },
                    approveToNextTask: {
                        1: 'task_mp_change',
                        2: 'task_scm_change',
                        12: 'task_change_init'
                    }
                },
                'task_mp_change': {
                    name: '工艺变更',
                    withComment: true,
                    approveToNextTask: 'EndEvent'
                },
                'task_scm_change': {
                    name: '采购通知&反馈',
                    withComment: true,
                    approveToNextTask: 'EndEvent'
                },
                'EndEvent': {
                    name: '结束'
                }
            }
        },
        theMaterial() {
            return this.$_emWorkflowTaskMixin_businessData.materialNumber;
        },
    },
    data() {
        return {
            differentHeads: null
        }
    },
    mounted() {
        if (this.$_emWorkflowTaskMixin_isShowTaskComplete) {
            this.tryGetDifferentHeads();
        }
    },
    methods: {
        tryGetDifferentHeads() {
            let status = this.$_emWorkflowTaskMixin_businessData.status;
            if (status === 'task_do_change') {
                this.$store.dispatch('api/get', {
                    url: process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdKamChange/bom/compare/differentHeads?material=" + this.theMaterial,
                    commonErrorHandle: false
                }).then(response => {
                    if (response) {
                        this.differentHeads = response;
                    }
                })
            }
        },
        downloadDifferentHeadsUrl() {
            return process.env.VUE_APP_SITHMES_PRD_URL + "/sithMesPrdKamChange/bom/compare/differentHeads/download?material=" + this.theMaterial;
        },
    },
};
</script>
